import { TFunction } from "i18next"
import React from "react"
import { Registry } from "./form-registry"

export const FormRendererContext = React.createContext<{
  tFunc: TFunction
  registry: Registry
  scope: Readonly<Record<string, unknown>>
} | null>(null)

export function useFormRenderer() {
  const context = React.useContext(FormRendererContext)
  if (!context) {
    throw new Error(
      "useFormRenderer must be used within a FormRendererProvider",
    )
  }
  return context
}
